export const IDENT22 = Object.freeze([1, 0, 0, 1]);
export const IDENT23 = Object.freeze([1, 0, 0, 1, 0, 0]);
//prettier-ignore
export const IDENT33 = Object.freeze([
    1, 0, 0,
    0, 1, 0,
    0, 0, 1
]);
//prettier-ignore
export const IDENT44 = Object.freeze([
    1, 0, 0, 0,
    0, 1, 0, 0,
    0, 0, 1, 0,
    0, 0, 0, 1
]);
